import React, { useRef, useState } from 'react';
import { ChartWrapper, TitleSection, Wrapper } from '../shared.styles';
import Input from '@/common/components/Input';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import { getCPLStats } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import CustomLine from '@/common/charts/Line';
import { SubTitle } from './CPLStats.styled';
import Icon from '@/common/components/Icon';

const CPLStats = () => {
	const [chartData, setChartData] = useState();

	const timeRangeRef = useRef();

	const { makeRequest } = useRequestsContext();

	const handleLoadData = async () => {
		setChartData(() => null);

		if (!parseInt(timeRangeRef.current?.value)) {
			return;
		}

		const payload = {};

		payload.days = timeRangeRef.current.value;

		const response = await makeRequest(getCPLStats.bind(null, payload));

		if (response.data) {
			setChartData(response.data);
		}
	};

	return (
		<Wrapper width={800}>
			<TitleSection>
				<SubTitle>
					<Icon name='money' />
					<div>Cost per lead (Netto)</div>
				</SubTitle>
				<SubTitle>
					<Input
						inputRef={timeRangeRef}
						inputWidth={50}
						showLabel={false}
						value={0}
					/>
					<Icon name='arrows-rotate' onClick={() => handleLoadData()} />
				</SubTitle>
			</TitleSection>
			<ChartWrapper>
				{chartData ? (
					<CustomLine data={chartData} />
				) : (
					<CustomSkeleton width={750} count={16} height={5} />
				)}
			</ChartWrapper>
		</Wrapper>
	);
};

export default CPLStats;
